
export default {
  name: 'YoutubePlayer',
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      attrs: {
        class: 'mx-auto',
        elevation: 2,
        'max-width': 854,
        type: 'image',
      },
      playerVars: {
        resize: true,
        autoplay: 0,
        rel: 0,
        modestbranding: 1,
        iv_load_policy: 3,
        playsinline: 1,
        showinfo: 0,
        enablejsapi: 1,
        title: 0,
      },
    }
  },
  computed: {
    src() {
      let url = new URL(`https://www.youtube.com/embed/${this.videoId}`)

      for (let [key, value] of Object.entries(this.playerVars)) {
        url.searchParams.append(key, value)
      }

      return url.href
    },
    player() {
      return this.$refs.plyr.player
    },
  },
  // beforeCreate() {
  //   console.log('(YoutubePlayer) SSR: ' + process.server + ' [BeforeCreate]')
  //   //if you tried to use this.sampleProp or this.sampleData, like in created or mounted, you'll get error indicating that this is undefined.
  // },
  // created() {
  //   console.log(
  //     '(YoutubePlayer) SSR: ' +
  //       process.server +
  //       ' [Created] ' +
  //       'Loading: ' +
  //       this.loading
  //   )
  //   console.log('(YoutubePlayer) Created Refs: ' + Object.keys(this.$refs))
  // },
  mounted() {
    let player = this.$refs.plyr.player

    // console.log(
    //   '(YoutubePlayer) SSR: ' +
    //     process.server +
    //     ' [Mounted] ' +
    //     'Loading: ' +
    //     this.loading +
    //     'Player:' +
    //     player
    // )
    // console.log('(YoutubePlayer) Mounted Refs: ' + Object.keys(this.$refs))

    player.on('ready', this.onReady, this)
  },
  methods: {
    onReady: function () {
      // console.debug('(YoutubePlayer) ready')
      this.loading = false
    },
  },
}
